import Button from 'components/Form/Button';
import { FormSeparator } from 'components/Form/Core/styled';
import { CoreContext } from 'context/CoreContext';
import { useContext, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { Update, UpdateParecer } from 'services/banking';
import { Update as UpdateFP } from 'services/financing-proposals';
import { Title } from 'ui/styled';
import { theme } from 'ui/theme-color';
import { parseCurrency } from 'utils/parsers';
import FormCore from '../../Form/Core';
import { TimelineContent } from '../BankingNegocios/styled';
import WrapperTwoCol from '../WrapperTwoCol';
import {
  AddProposalContainer,
  ButtonsAndInputWrapper,
  CompanyButtonContainer,
  TimelineContainer,
  TimelineItem,
} from './styled';

export default function CuradoriaCredito({ dados: data, reload }) {
  const { setModal, user } = useContext(CoreContext);
  const formRefProposta = useRef(null);
  const formRefPerfil = useRef(null);
  const formRefParecer = useRef(null);
  const [showParecer, setShowParecer] = useState(false);
  const [loading, setLoading] = useState(false);

  const close = () => setModal(null);

  const formProposta = [
    {
      ref: 'valor_venda',
      placeholder: 'Valor Total da Venda (R$)',
      tress: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'valor_entrada',
      placeholder: 'Valor Entrada (R$)',
      tress: true,
      type: 'money',
      required: false,
      disabled: true,
      transparent: false,
    },
    {
      ref: 'valor_financiamento',
      placeholder: 'Valor Financiado (R$)',
      tress: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'taxa',
      placeholder: 'Taxa ',
      tress: true,
      type: 'string',
      required: false,
      disabled: true,
      transparent: false,
    },
    {
      ref: 'carencia',
      placeholder: 'Carência (dias)',
      tress: true,
      type: 'select',
      required: false,
      disabled: true,
      transparent: false,
    },
    {
      ref: 'prazo_financiamento',
      placeholder: 'Prazo',
      tress: true,
      type: 'select',
      required: false,
      disabled: true,
      transparent: false,
    },
    {
      ref: 'tac',
      placeholder: 'TAC',
      tress: true,
      type: 'money',
      required: false,
      disabled: true,
      transparent: false,
    },
    {
      ref: 'seguro',
      placeholder: 'Seguro Prestamista',
      tress: true,
      type: 'select',
      required: false,
      disabled: true,
      transparent: false,
    },
    {
      ref: 'seguro_assistencia',
      placeholder: 'Seguro de Assistência',
      tress: true,
      type: 'select',
      required: false,
      disabled: true,
      transparent: false,
    },
    {
      ref: 'tab',
      placeholder: 'TAB',
      tress: true,
      type: 'select',
      required: false,
      disabled: true,
      transparent: false,
    },
    {
      ref: 'iof',
      placeholder: 'IOF',
      tress: true,
      type: 'select',
      required: false,
      disabled: true,
      transparent: false,
    },
    {
      ref: 'valor_parcelas',
      placeholder: 'PMT',
      tress: true,
      type: 'money',
      required: false,
      transparent: false,
      readOnly: true,
      style: {
        backgroundColor: theme.palette.purple.main,
        color: theme.palette.purple.contrastText,
      },
    },
  ];

  const formPerfil = [
    {
      ref: 'perfil',
      placeholder: 'Classificação Julia',
      half: true,
      disabled: true,
      transparent: false,
    },
    {
      ref: 'taxa_sugerida',
      placeholder: 'Taxa Sugerida',
      half: true,
      type: 'number',
      required: false,
      disabled: true,
      transparent: false,
    },
  ];

  const formParecer = [
    {
      ref: 'obs',
      placeholder: 'Observações',
      full: true,
      required: true,
      disabled: false,
    },
  ];

  const credito = async () => {
    try {
      setLoading(true);
      const form = await formRefParecer.current.getForm?.();
      if (!form) {
        return;
      }
      const newParecer = [
        ...data?.parecer,
        {
          usuario: user.id,
          data: new Date(),
          message: `${form.obs}`,
          origem: 'Curadoria',
        },
      ];
      const payload = {
        status: 'aprovar',
        parecer: newParecer,
        data_credito: new Date(),
      };
      const payloadCuradoria = { curadoria_analise: 'Analisado' };
      const result = await Update({ data: payload }, data.id);
      const resultProp = await UpdateFP(
        { data: payloadCuradoria },
        data.id_proposal
      );
      if (result.status !== 200 && resultProp.status !== 200) {
        throw new Error('Erro ao salvar');
      }
      toast.success('Registro salvo com sucesso!');
      close();
      reload?.();
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Erro ao salvar');
    } finally {
      setLoading(false);
    }
  };

  const reprova = async () => {
    try {
      setLoading(true);
      const form = await formRefParecer.current.getForm?.();
      if (!form) {
        return;
      }
      const newParecer = [
        ...data?.parecer,
        {
          usuario: user.id,
          data: new Date(),
          message: `MOTIVO REPROVAÇÃO: ${form.obs}`,
          origem: 'Curadoria',
        },
      ];
      const payload = {
        status: 'recusado',
        parecer: newParecer,
        proposta_financeira: data.id_proposal,
        proposta_bancaria: data.proposta_financeira.propostas_banco[0].id,
      };
      const result = await UpdateParecer({ data: payload }, data.id);
      if (result.status !== 200) {
        throw new Error('Erro ao salvar');
      }
      toast.success('Registro salvo com sucesso!');
      close();
      reload?.();
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Erro ao salvar');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // #region == Bureau ==
    formRefProposta.current.setItem(data?.rating_julia, 'classificacao_julia');
    formRefProposta.current.setItem(
      data?.crivo_payload?.serasa_restritivos,
      'serasa_restritivos'
    );

    formRefProposta.current.setItem(data.value, 'valor_venda');
    formRefProposta.current.setItem(
      data?.proposta_financeira?.propostas_banco[0]?.valor_entrada,
      'valor_entrada'
    );
    formRefProposta.current.setItem(
      parseCurrency(
        data?.proposta_financeira?.informacoes_projeto?.custo_total_projeto -
          data?.proposta_financeira?.propostas_banco[0]?.valor_entrada
      ),
      'valor_financiamento'
    );
    formRefProposta.current.setItem(
      parseCurrency(
        data?.proposta_financeira?.propostas_banco[0]?.valor_parcelas
      ),
      'valor_parcelas'
    );
    formRefProposta.current.setItem(
      String(
        data?.proposta_financeira?.propostas_banco[0]?.prazo_financiamento
      ),
      'prazo_financiamento'
    );

    formRefProposta.current.setItem(data?.taxa, 'taxa');
    formRefProposta.current.setItem(
      data?.proposta_financeira?.propostas_banco[0]?.carencia,
      'carencia'
    );
    formRefProposta.current.setItem(
      parseCurrency(data?.proposta_financeira.propostas_banco[0].iof),
      'iof'
    );
    formRefProposta.current.setItem(
      parseCurrency(data?.proposta_financeira.propostas_banco[0].seguro),
      'seguro'
    );
    formRefProposta.current.setItem(
      parseCurrency(
        data?.proposta_financeira.propostas_banco[0].seguro_assistencia
      ),
      'seguro_assistencia'
    );
    formRefProposta.current.setItem(
      parseCurrency(data?.proposta_financeira.propostas_banco[0].tab),
      'tab'
    );
    formRefProposta.current.setItem(
      parseCurrency(data?.proposta_financeira.propostas_banco[0].tac),
      'tac'
    );

    // perfil
    formRefPerfil.current.setItem(data?.rating_julia, 'perfil');
    formRefPerfil.current.setItem(data?.taxa_sugerida, 'taxa_sugerida');

    // #endregion

    formRefProposta.current.setItem(data?.bureau_observacoes, 'obs');
    // #endregion
  }, [data]);
  if (!data) {
    return null;
  }

  return (
    <WrapperTwoCol
      onClose={close}
      title={'Informações'}
      children={
        <AddProposalContainer>
          <TimelineContainer>
            {data?.reprovado.map((rep, idx) => (
              <TimelineItem key={idx}>
                <TimelineContent>
                  <div style={{ marginBottom: '4px' }}>
                    <strong style={{ color: '#2d3748', fontSize: '14px' }}>
                      {rep.regra}
                    </strong>
                  </div>
                  <span
                    style={{
                      fontSize: '15px',
                      color: '#4a5568',
                      lineHeight: '1.4',
                    }}
                  >
                    {rep.detalhe}
                  </span>
                </TimelineContent>
              </TimelineItem>
            ))}
          </TimelineContainer>
        </AddProposalContainer>
      }
      titleColumn1="Motivo(s) da reprovação"
      width="90vw"
      children2={
        <AddProposalContainer>
          <FormCore ref={formRefProposta} formItems={formProposta} />
          <FormSeparator />
          <FormCore ref={formRefPerfil} formItems={formPerfil} />
          <FormSeparator />
        </AddProposalContainer>
      }
      titleColumn2="Proposta"
      footer={
        <div style={{ marginTop: '10px', width: '100%' }}>
          <div
            onClick={() => setShowParecer(!showParecer)}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              background: '#fff',
              padding: '10px',
              borderRadius: '4px',
            }}
          >
            <Title nomargin>Parecer:</Title>
          </div>
          <ButtonsAndInputWrapper>
            <FormCore ref={formRefParecer} formItems={formParecer} />
            <CompanyButtonContainer>
              <Button color="secondary" onClick={reprova} nospace>
                {loading ? 'Processando' : 'Reprovar'}
              </Button>
              <Button onClick={credito} color="blue" nospace>
                {loading ? 'Processando' : 'Enviar para Credito'}
              </Button>
            </CompanyButtonContainer>
          </ButtonsAndInputWrapper>
        </div>
      }
    />
  );
}
